
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { currencyConfig, type CurrencyCode } from "@/utils/currency";

interface JobCompensationProps {
  salaryRangeMin: string;
  salaryRangeMax: string;
  salaryCurrency: CurrencyCode;
  onFieldChange: (field: string, value: string) => void;
}

export const JobCompensation = ({
  salaryRangeMin,
  salaryRangeMax,
  salaryCurrency,
  onFieldChange,
}: JobCompensationProps) => {
  const currentCurrency = currencyConfig[salaryCurrency];
  const CurrencyIcon = currentCurrency.icon;

  return (
    <div className="space-y-4">
      <Label>Compensation Range</Label>
      <div className="flex items-start gap-4">
        <Select
          value={salaryCurrency}
          onValueChange={(value: CurrencyCode) => onFieldChange('salaryCurrency', value)}
        >
          <SelectTrigger className="w-[120px]">
            <SelectValue>{salaryCurrency}</SelectValue>
          </SelectTrigger>
          <SelectContent>
            {Object.entries(currencyConfig).map(([code, config]) => (
              <SelectItem key={code} value={code}>
                <div className="flex items-center gap-2">
                  {config.icon && <config.icon className="h-4 w-4" />}
                  <span>{config.name} ({code})</span>
                </div>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <div className="relative flex-1">
          {CurrencyIcon && (
            <CurrencyIcon className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
          )}
          <Input
            id="salaryRangeMin"
            type="number"
            min="0"
            value={salaryRangeMin}
            onChange={(e) => onFieldChange('salaryRangeMin', e.target.value)}
            placeholder="Min salary"
            className={CurrencyIcon ? "pl-9" : "pl-3"}
          />
        </div>

        <div className="relative flex-1">
          {CurrencyIcon && (
            <CurrencyIcon className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
          )}
          <Input
            id="salaryRangeMax"
            type="number"
            min="0"
            value={salaryRangeMax}
            onChange={(e) => onFieldChange('salaryRangeMax', e.target.value)}
            placeholder="Max salary"
            className={CurrencyIcon ? "pl-9" : "pl-3"}
          />
        </div>
      </div>
    </div>
  );
};
